import Swiper, { Autoplay, Navigation } from 'swiper';

let locationsButtonsSwiperWr = document.querySelectorAll('.locations-buttons-swiper-wr');
locationsButtonsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
     let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 0,
      slidesPerView: 'auto',
      threshold: 10,
      slideToClickedSlide: true,
    });
  }
});